import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { CaseIncident } from "../_types/case-incident";

@Injectable({
    providedIn: 'root',
})
export class CasesIncidentsService extends Service<CaseIncident> {
    public override type = 'caseIncidents';
    public override url = 'attendance/caseIncidents';
      
}
